import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import 'assets/scss/components/locationModal.css';
import LocationForm from '../businessLocation/locationForm';

const LocationModal = ({ isVisible, handleSubmit, onCancel, locationData }) => {
  return (
    <Modal
      className="location-modal"
      isOpen={isVisible}
      toggle={onCancel}
      onClickBackdrop={onCancel}
    >
      <ModalHeader className="text-center">
        <div className="modal-title d-inline text-bold">Edit Location</div>
        <span role="none" className="close-modal" onClick={onCancel}>
          <FontAwesomeIcon icon="times" />
        </span>
      </ModalHeader>
      <ModalBody>
        <LocationForm
          locationData={locationData}
          onSubmit={handleSubmit}
          onCancel={onCancel}
        />
      </ModalBody>
    </Modal>
  );
};

LocationModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  toggleRemoveOnboardingModal: PropTypes.func,
};

export default LocationModal;



// WEBPACK FOOTER //
// ./src/components/businessDetail/modal/locationModal.js